/**
 * Daily PnL Pill — Topbar'da sürekli görünür.
 *
 * Kullanıcı "Bugünkü K/Z" için Dashboard'a koşmak zorunda kalmasın.
 * Aynı zamanda daily loss limit'e yakınlık görsel feedback'i verir
 * (kırmızı renk + yüzde).
 */
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";

export default function DailyPnlPill() {
  const { data } = useQuery({
    queryKey: ["daily-loss-status"],
    queryFn: () => http.get("/positions/daily-loss-status").then((r) => r.data),
    refetchInterval: 8000,
    retry: 1,
    staleTime: 4000,
  });

  if (!data) {
    return (
      <span data-testid="topbar-daily-pnl-loading"
            className="text-[10px] text-zinc-500 px-2">…</span>
    );
  }

  const v = Number(data.today_net || 0);
  const limit = Number(data.limit || 0);
  const usedPct = Number(data.used_pct || 0);
  const isLoss = v < 0;
  const sign = v > 0 ? "+" : "";
  const text = `${sign}$${Math.abs(v).toFixed(2)}`;

  let color = "#4ade80";
  let bg = "rgba(74, 222, 128, 0.08)";
  let border = "rgba(74, 222, 128, 0.25)";
  let warn = null;
  if (isLoss) {
    if (usedPct >= 80) {
      color = "#fb7185"; bg = "rgba(251,113,133,0.10)"; border = "rgba(251,113,133,0.45)";
    } else if (usedPct >= 50) {
      color = "#fbbf24"; bg = "rgba(251,191,36,0.08)"; border = "rgba(251,191,36,0.30)";
    } else {
      color = "#fda4af"; bg = "rgba(253,164,175,0.05)"; border = "rgba(253,164,175,0.20)";
    }
    if (limit > 0) warn = `${usedPct}% limit`;
  } else if (v > 0) {
    warn = "kâr";
  }

  return (
    <Link
      to="/analytics"
      data-testid="topbar-daily-pnl"
      title={`Bugün gerçekleşen net: ${text}${limit > 0 ? ` · Limit -$${limit.toFixed(0)}` : ""}`}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        height: 28, padding: "0 10px",
        background: bg, border: `1px solid ${border}`,
        color, fontSize: 11, fontWeight: 700,
        letterSpacing: "0.03em",
        fontFamily: "ui-monospace, SFMono-Regular, monospace",
        fontVariantNumeric: "tabular-nums",
        textDecoration: "none",
      }}
    >
      <span style={{
        width: 5, height: 5, borderRadius: "50%",
        background: color, boxShadow: `0 0 6px ${color}`,
      }} />
      BUGÜN {text}
      {warn && (
        <span style={{
          fontSize: 9, fontWeight: 500, opacity: 0.85, marginLeft: 2,
          letterSpacing: "0.1em", textTransform: "uppercase",
        }}>
          {warn}
        </span>
      )}
    </Link>
  );
}
